import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'
import PlannerCardList from '../atoms/planner-card/PlannerCardList'
import styles from './plannerListStyle.module.scss'

const PlannerListView = () => {
	const planners = useSelector((s) => s.planner.plannerSearchList)
	return (
		<div className={styles.venderListView}>
			<Grid container spacing={2}>
				{planners?.length > 0 &&
					planners.map((item) => (
						<Grid size={{ xs: 12 }} key={item._id}>
							<PlannerCardList data={item} />
						</Grid>
					))}
			</Grid>
		</div>
	)
}

export default PlannerListView
